module.exports = __webpack_public_path__ + "img/chatkit-basic.6831fc65.png";